var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('group-item',[_c('v-btn',{nativeOn:{"click":function($event){return _vm.onPreview.apply(null, arguments)}}},[_c('span',[_vm._v("Preview")]),_c('v-icon',{staticClass:"play-icon"},[_vm._v("mdi-play")])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }